import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { ArrowUpRight } from "lucide-react";

export default function Capabilities() {
  const { t } = useLang();
  return (
    <section id="capabilities" className="py-24 md:py-32 bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-16">
          <div className="md:col-span-8">
            <div className="section-label mb-5">{t.capabilities.label}</div>
            <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
              {t.capabilities.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10">
          {t.capabilities.items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group bg-[#0A0A0A] p-8 md:p-12 relative hover:bg-[#141414] transition-colors duration-300 cursor-default"
            >
              <div className="flex items-start justify-between gap-6">
                <div className="font-heading text-[#F5B800]/40 text-3xl group-hover:text-[#F5B800] transition-colors">
                  {item.n}
                </div>
                <ArrowUpRight className="text-neutral-600 group-hover:text-[#F5B800] transition-colors" size={22} />
              </div>
              <h3 className="mt-8 font-heading uppercase text-white text-2xl md:text-3xl tracking-wide">
                {item.t}
              </h3>
              <p className="mt-4 text-neutral-400 text-sm md:text-base leading-relaxed max-w-md">
                {item.d}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
